import { Button, Card, Checkbox, CircularProgress, Divider, Grid, Modal, Typography } from '@mui/material';
import * as React from 'react';
import  { TextField, IconButton, FormLabel, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { CheckBox, Close } from '@mui/icons-material';
import { BlackButton, OutlinedBlackButton } from '../../Styles/Button';
import { CustomTextField } from '../../Styles/TextField';
import { useMediaQuery } from '@mui/material';
import { ClassicModal } from '../../Styles/Modal';
import { Link } from 'react-router-dom';
import api from '../../Api/api';
import { useSelector } from 'react-redux'
import { selectProducts } from '../../Store/panierReducer';
import axios from 'axios';
import { ModalUnavailable } from '../ModalNonAvailableProduct';



export const ModalReservation = props => {

    const { isOpen, setIsOpen } = props
    const cart = useSelector(selectProducts)
    const isAnyBoutique = (item) => {
        return item.product.type === "boutique";
    }

    const initialState = {
        name: '',
        surname: '',
        mail: '',
        phone: '',
        address: '',
        complement: '',
        city: '',
        postalcode: '',
        country: '',
        shipping: cart.some(isAnyBoutique) ? 'withdrawal' : 'none'
    };
    
    const [{ name, surname, mail, phone, address, complement, city, postalcode, country, shipping }, setState] = React.useState(initialState);    
    const [isLoading, setIsLoading] = React.useState(false)
    const [isError, setIsError] = React.useState()
    const [unavailableProduct, setUnavailableProduct] = React.useState([])
    const [isModalUnavailableOpen, setIsModalUnavailableOpen] = React.useState(false)
    const [isChecked, setIsChecked] = React.useState(false);
    const [isSmall, setIsSmall] = React.useState(false);

    // Gestion de la taille de l'écran
    React.useEffect(() => {
        const checkScreenSize = () => {
            setIsSmall(window.matchMedia('(max-width: 600px)').matches);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    const handleChange = itemKey => event => {
        let result = event.target.value
        // result = typeof result === 'string' ? result.trim() : result;
        setState(prevState => {
            const states = { ...prevState };
            states[itemKey] = result;
            return states;
        });
    };

    const verificationCart = async (cart) => {
        const missingProducts = []
        for (const element of cart) {
            const produit = await api.getProduit(element.product._id);
            const availableQuantity = produit.totalUnits - produit.bookedUnits;
            if (availableQuantity < element.quantity) {
                missingProducts.push({
                    product: element.product,
                    availableQuantity,
                    wantedQuantity: element.quantity
                });
            }
        }
        // Mise à jour synchrone des états après la vérification
        return new Promise((resolve) => {
            if (missingProducts.length !== 0 ) {
                setUnavailableProduct(missingProducts);
                setIsModalUnavailableOpen(true);
                resolve(false);
            } else {
                setUnavailableProduct([]);
                resolve(true);
            }
        });
    };

    React.useEffect(() => {
        verificationCart(cart);
    }, []);

    const handleClick = async () => {
        setIsLoading(true);
        if (!cart.some(isAnyBoutique)) {
            setState(prevState => ({
              ...prevState,
              shipping: 'none'
            }));
        }
        const allAvailable = await verificationCart(cart);
        if (!allAvailable) {
            return;
        }
        if (
            nameError(name) 
            || nameError(surname)
            || mailError(mail)
            || phoneError(phone)
            || !isChecked
            || addressError(address)
            || nameError(city)
            || nameError(country)
            || postalcodeError(postalcode)
        ) {
            setIsError(true)
            setIsLoading(false)
        }
        else {
            setIsError(false)
            const { _id } = await handleModalValidation({
                name,
                surname,
                mail,
                phone,
                address: {
                    address,
                    complement,
                    city,
                    country,
                    postalcode
                }
            })
            const stripeCart = []
            for (const element of cart) {
                stripeCart.push({
                    name: element.product.title,
                    description: element.product.subtitle,
                    price: element.product.price * 100,
                    quantity: element.quantity,
                    produitId: element.product._id
                })
            }
            const customerInfo = JSON.stringify({ mail, orderId: _id })
            
            const { stripeUrl, sessionId } = await api.createCheckoutSession(customerInfo, stripeCart);
            if (stripeUrl) {
                //window.history.replaceState(null, null, `http://localhost:3000/payement?canceled=true&session_id=${sessionId}`);
                window.history.replaceState(null, null, `https://lechai-metz.com/payement?canceled=true&session_id=${sessionId}`);
                window.location.href = stripeUrl;
            }
        }
    };

    const handleModalValidation = async (newCustomer) => {
        const customerExist = await api.getCustomerByMail(newCustomer?.mail);
        let customer
        if (!customerExist) {
            customer = await api.createCustomer(newCustomer);
        } else {
            customer = await api.updateCustomer(customerExist?._id, newCustomer);
        }
        const newOrder = {
            products: [],
            customerId: customer._id,
            totalPrice: 0,
            status: 'unpaid',
            sessionId: '',
            shipping: shipping
        }
        for (const produit of cart) {
            await api.handleBuyerToProduit(
                produit?.product?._id,
                customer?._id,
                produit?.quantity,
                "add",
                "unitsOnly"
            );
            newOrder.products.push({
                produitId: produit?.product?._id,
                quantity: produit?.quantity,
                unitPrice: produit?.product?.price
            })
        }
        const order = await api.createOrder(newOrder);
        return order;
    }

    const nameError = (name) => { return (!(/^[A-Za-zÀ-ÿ'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{0,19}$/).test(name)); }
    const mailError = (mail) => { return !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/).test(mail); }
    const phoneError = (phone) => { return !(/^\d{10}$/).test(phone); }
    const postalcodeError = (postalcode) => { return !(/^(?=.*\d)[A-Za-z0-9\-]{3,8}$/).test(postalcode); }
    const addressError = (address) => { return !(/^(?=.*\d)(?=.*[A-Za-zÀ-ÿ])[A-Za-zÀ-ÿ0-9\s\-/]{2,30}$/).test(address); }

    return(
        <div>
        <ClassicModal sx={{
            overflowY: 'auto',
            width: "40%",
            height: "fit-content",
            margin: "auto",
            alignContent: "center"
            }}
            display="flex"
            open={isOpen}
            onClose={(e, reason) => (reason && reason === "backdropClick") ? setIsOpen(!isOpen) : null}>
                <Card id="modal" display="flex">
                    <IconButton
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                        onClick={() => setIsOpen(false)}
                    >
                        <Close/>
                    </IconButton>
                    <Grid
                        display="flex"
                        container
                        padding={5}
                        rowSpacing={{xs: 2, md: 2}}
                        columnSpacing={1}
                        direction="row"
                        margin="center"
                        justifyItems="center"
                        textAlign="center"
                    >   
                        <Grid item xs="12">
                            <Typography sx = {{
                                textAlign: "left",
                                fontSize: "30px",
                                fontWeight: "bold"
                            }}>Finalisez votre achat !</Typography>
                            <Divider sx={{paddingTop: 1, borderBottomWidth: 2}} variant="fullWidth" orientation="horizontal" flexItem/>
                            <Typography sx = {{
                                textAlign: "left",
                                fontSize: "20px",
                                paddingTop: 2
                            }}>Renseignez vos informations :</Typography>
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="name-textField"
                                label="Prénom"
                                placeholder=" ex: Jean"
                                variant="outlined"
                                required
                                error={nameError(name) && isError}
                                helperText={(nameError(name) && isError) ? "Rentrer un prénom valide" : null}
                                value={name}
                                onChange={value => handleChange('name')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="surname-textField"
                                label="Nom"
                                placeholder="ex: Dupont"
                                variant="outlined"
                                required
                                error={nameError(surname) && isError}
                                helperText={(nameError(surname) && isError) ? "Rentrer un nom valide" : null}
                                value={surname}
                                onChange={value => handleChange('surname')(value)}
                            />
                        </Grid>
                        <Grid item xs="12">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="mail-textField"
                                label="Adresse mail"
                                placeholder="ex: jean.dupont@gmail.com"
                                variant="outlined"
                                required
                                error={mailError(mail) && isError}
                                helperText={(mailError(mail) && isError) ? "Rentrer une adresse mail valide" : null}
                                value={mail}
                                onChange={value => handleChange('mail')(value)}
                            />
                        </Grid>
                        <Grid item xs="12">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="phone-textField"
                                label="Téléphone"
                                placeholder="ex: 06 55 44 77 11"
                                variant="outlined"
                                required
                                error={phoneError(phone) && isError}
                                helperText={(phoneError(phone) && isError) ? "Rentrer un numéro valide" : null}
                                value={phone}
                                onChange={value => handleChange('phone')(value)}
                            />
                        </Grid>
                        {cart.some(isAnyBoutique) && (
                        <>
                            <Grid item xs="12">
                                <Typography sx = {{
                                    textAlign: "left",
                                    fontSize: "20px",
                                    paddingTop: 2
                                }}>Choisissez comment récupérer votre commande :</Typography>
                            </Grid>
                            <Grid item xs="12">
                                <RadioGroup
                                    name="radio-buttons-group"
                                    value={shipping}
                                    onChange={value => handleChange('shipping')(value)}
                                >
                                    <FormControlLabel
                                        sx={{ paddingBottom: isSmall ? 2 : 1}}
                                        value="withdrawal"
                                        control={<Radio size={ isSmall ? 'small' : 'medium' }/>}
                                        label={<Typography fontSize={15} textAlign={'left'}>Retrait au 332 rue Lieutenant-colonel Dagnaux, 57685 Augny</Typography>}
                                    />
                                    <FormControlLabel
                                        value="delivery"
                                        control={<Radio size={ isSmall ? 'small' : 'medium' }/>}
                                        label={<Typography fontSize={15} textAlign={'left'}>Livraison à domicile (veuillez nous contacter de manière à définir les détails de l'envoi)</Typography>}
                                    />
                                </RadioGroup>
                            </Grid>
                        </>)}
                        <Grid item xs="12">
                            <Typography sx = {{
                                textAlign: "left",
                                fontSize: "20px",
                                paddingTop: 2
                            }}>
                                {shipping === 'delivery' ? 'Renseignez votre adresse de livraison : ' : 'Renseignez votre adresse de facturation : '}
                            </Typography>
                        </Grid>
                        <Grid item xs="12">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="address-textField"
                                label="Adresse"
                                placeholder=" ex: 12 rue du Pêcheur"
                                variant="outlined"
                                required
                                error={addressError(address) && isError}
                                helperText={(addressError(address) && isError) ? "Rentrer une adresse valide" : null}
                                value={address}
                                onChange={value => handleChange('address')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="complement-textField"
                                label="Complément"
                                placeholder="ex: 4ème étage"
                                variant="outlined"
                                error={complement !== "" ? addressError(complement) && isError : null}
                                helperText={(addressError(complement) && isError && complement !== "") ? "Rentrer un complément valide" : null}
                                value={complement}
                                onChange={value => handleChange('complement')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="city-textField"
                                label="Ville"
                                placeholder="ex: Metz"
                                variant="outlined"
                                required
                                error={nameError(city) && isError}
                                helperText={(nameError(city) && isError) ? "Rentrer une ville valide" : null}
                                value={city}
                                onChange={value => handleChange('city')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="postalcode-textField"
                                label="Code postal"
                                placeholder="ex: 57000"
                                variant="outlined"
                                required
                                error={postalcodeError(postalcode) && isError}
                                helperText={(postalcodeError(postalcode) && isError) ? "Rentrer un code postal valide" : null}
                                value={postalcode}
                                onChange={value => handleChange('postalcode')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size={ isSmall ? 'small' : 'medium' }
                                fullWidth
                                id="country-textField"
                                label="Pays"
                                placeholder="ex: France"
                                variant="outlined"
                                required
                                error={nameError(country) && isError}
                                helperText={(nameError(country) && isError) ? "Rentrer un pays valide" : null}
                                value={country}
                                onChange={value => handleChange('country')(value)}
                            />
                        </Grid>
                        {isLoading && 
                        <Grid item xs="12">
                            <CircularProgress color="inherit" />
                        </Grid>
                        }
                        <Grid item xs="12">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isChecked}
                                        onChange={() => setIsChecked(!isChecked)}
                                        color="default"
                                        sx={{
                                            color: isError && !isChecked
                                                ? '#c62828'
                                                : '#16191e'
                                        }}
                                    />
                                }
                                label={
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingY: 1,
                                            color: isError && !isChecked
                                                ? '#c62828'
                                                : '#16191e'
                                        }}
                                    >
                                        J'accepte les CGV <br />
                                        <Link 
                                            component={Link} 
                                            to="/terms"
                                            style={{ marginLeft: 10 }}
                                        >
                                            En savoir plus
                                        </Link>
                                    </Typography>
                                }
                            />
                        </Grid>
                        <Grid item xs="12">
                            <BlackButton
                            sx={{
                                marginY: 0
                            }}
                                onClick={handleClick}
                            >
                                Passer au paiement
                            </BlackButton>
                        </Grid>
                    </Grid>
                </Card>
        </ClassicModal>
        <ModalUnavailable
            isModalUnavailableOpen={isModalUnavailableOpen}
            setIsModalUnavailableOpen={setIsModalUnavailableOpen}
            unavailableProduct={unavailableProduct}
        />
        </div>
    )
}

export default ModalReservation
